import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';

export default withStyles(theme => ({
  paper: {
    margin: theme.spacing(1),
    minWidth: '95%',
  },
}))(Dialog);
